import { render, staticRenderFns } from "./ActivitiesSelector.vue?vue&type=template&id=799d0458&scoped=true"
import script from "./ActivitiesSelector.vue?vue&type=script&lang=ts"
export * from "./ActivitiesSelector.vue?vue&type=script&lang=ts"
import style0 from "./ActivitiesSelector.vue?vue&type=style&index=0&id=799d0458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799d0458",
  null
  
)

export default component.exports